import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { CheckCircle2, Clock } from 'lucide-react';
import { practiceComplianceAPI as API } from '../../lib/practiceComplianceAPI';

export const PMAcknowledgementsTab = () => {
  const [matrix, setMatrix] = useState(null);

  useEffect(() => {
    API.ackMatrix().then((res) => setMatrix(res.data.matrix || [])).catch(() => setMatrix([]));
  }, []);

  if (matrix === null) return <div className="animate-pulse h-48 bg-muted rounded-lg mt-4" />;
  if (matrix.length === 0) {
    return (
      <Card className="mt-4"><CardContent className="py-10 text-center text-muted-foreground">
        No effective manuals yet — acknowledgements are tracked once a manual is approved and effective.
      </CardContent></Card>
    );
  }

  return (
    <div className="space-y-4 mt-4">
      {matrix.map((m) => {
        const pending = m.staff.filter((s) => !s.acknowledged_at);
        return (
          <Card key={m.manual_id} data-testid={`pm-ack-matrix-${m.manual_id}`}>
            <CardHeader className="pb-2">
              <CardTitle className="text-base flex items-center justify-between">
                <span>{m.name} — v{m.version}</span>
                <Badge className={pending.length ? 'bg-orange-100 text-orange-800' : 'bg-green-100 text-green-800'}>
                  {pending.length ? `${pending.length} pending` : 'All acknowledged'}
                </Badge>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <Table>
                <TableHeader><TableRow className="bg-muted/50">
                  <TableHead>Staff member</TableHead><TableHead>Role</TableHead><TableHead>Status</TableHead><TableHead>Acknowledged</TableHead>
                </TableRow></TableHeader>
                <TableBody>
                  {m.staff.map((s) => (
                    <TableRow key={s.user_id}>
                      <TableCell className="text-sm">{s.name}</TableCell>
                      <TableCell className="text-xs text-muted-foreground capitalize">{s.role}</TableCell>
                      <TableCell>
                        {s.acknowledged_at
                          ? <span className="flex items-center gap-1 text-green-700 text-sm"><CheckCircle2 className="w-4 h-4" /> Acknowledged</span>
                          : <span className="flex items-center gap-1 text-orange-700 text-sm"><Clock className="w-4 h-4" /> Pending</span>}
                      </TableCell>
                      <TableCell className="text-xs text-muted-foreground">
                        {s.acknowledged_at ? new Date(s.acknowledged_at).toLocaleString('en-AU') : '—'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
